<template>
  <pt-waiting-sample-recollect class="pt-waiting-sample-recollect__withData" @exportResampleOrder="exportResampleOrder" ref="table" :pageSize="pageSize" :exportLoading="exportLoading"></pt-waiting-sample-recollect>
</template>

<script>
import PtWaitingSampleRecollect from './index'
import { dataExport } from 'utils/formUtils'
export default {
  name: 'pt-waiting-sample-recollect__withData',
  components: {
    'pt-waiting-sample-recollect': PtWaitingSampleRecollect
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      pageSize: 10,
      exportLoading: false
    }
  },
  methods: {
    exportResampleOrder () {
      let data = {
        pageable: {
          page: this.page,
          size: this.pageSize
        }
      }
      this.exportLoading = true
      this.$store.dispatch('exportResampleOrder', data).then(res => {
        this.exportLoading = false
        dataExport(res)
      }).catch(err => {
        this.exportLoading = false
        this.$message(err || '导出订单失败')
      })
    }
  }
}
</script>
